export * from './categories.service';
export * from './configuration.service';
export * from './markets.service';
export * from './media.service';
export * from './pages.service';
export * from './permissions.service';
export * from './product-settings.service';
export * from './products.service';
export * from './settings.service';
export * from './subcategories.service';
export * from './translations.service';
export * from './users.service';
export * from './variant-edit.service';
export * from './variants.service';
export * from './plugin-gotenehus-mapping.service';
export * from './plugin-gotenehus-mapping-data.service';



// WEBPACK FOOTER //
// ./src/app/pages-services/index.ts